export const PUBLIC_EXTERNAL_FORM_SOURCE_SYSTEMS = Object.freeze([
  "public-form-widget",
  "public-inline-form",
  "public-inline-file-form",
  "public-data-collection-form",
]);
